export enum CognitoCustomerRoute {
  SIGN_IN = '/v2/auth/sign-in',
  SIGN_UP = '/v2/auth/sign-up',
  FORGOT = '/v2/auth/forgot-password',
  RESET = '/v2/auth/confirm-forgot-password',
  OTP_VERIFY = '/v2/auth/verify-otp',
  OTP_RESEND = '/v2/auth/resend-otp',
  GOOGLE_AUTH_COMPLETE = '/v2/auth/google-sign-in/complete',
  SET_PASSWORD = '/v2/auth/set-password',
  CURRENT_USER = '/v2/customers/token',
}

export enum OtpPurpose {
  SIGN_IN = 'SIGN_IN',
}

export enum SignInAuthChallenge {
  PASSWORD = 'PASSWORD',
  EMAIL_OTP = 'EMAIL_OTP',
}

export enum AuthState {
  PASSWORD = 'PASSWORD',
  NO_PASSWORD = 'NO_PASSWORD',
  SOCIAL = 'SOCIAL',
  NOT_FOUND = 'NOT_FOUND',
}
